// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InstallerInitialConfigHeader from '../../../components/InitialConfig/InstallerInitialConfigHeader';
import StepIntro from '../../../components/InitialConfig/StepIntro'
import InstallerImg from '../../../img/dark-theme/installer.png'
import ReactGA from "react-ga4";

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

function recuperarNombre(){

  var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        
  userData = JSON.parse(userData);

  var nombre = ""
  
  for (var i = 0; i < userData.UserAttributes.length; i++) {
      if(userData.UserAttributes[i].Name === "name"){
        nombre = userData.UserAttributes[i].Value            
      }
  }

  return nombre
}

// Initial config - Welcome
const Welcome = () => {
  
  useEffect(() => {    
    if(initialConfigCommonJS.antiBackOnboarding() === false){
      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("WELCOME_INSTALLER")
      document.title = "HELIAS Instalador - Configuración inicial: Bienvenida"    
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - WELCOME', "", "")
    }

  }, []);

  const navigate = useNavigate();
    
  function navegar(){    
    if(initialConfigCommonJS.existeSesion()){
      // Y continuo a la siguiente página
      
      console.log(localStorage.getItem("ongoingInstallationConfiguration"))
      
      if ( (localStorage.getItem("ongoingInstallationConfiguration") !== null ) && (localStorage.getItem("ongoingInstallationConfiguration") !== "NEW") ){  
        navigate("/InstallerInitialConfig/GeneralInfo")         
      }
      else{ initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...', "") }    
    }
  }

  return (      
    <main>

      <InstallerInitialConfigHeader step={"WELCOME"}/>

      <section id="welcome-01" className="step wrapper">
        <div className="content-wrapper half">          
          
          <StepIntro 
            Title={"Hola "+recuperarNombre()}
            Intro={
              <>
              <p>Soy Helias, encantado de conocerte. A partir de ahora te ayudaré con las instalaciones que hayas realizado:</p>               
              <ul className="default-list">                
                <li className="success">Con un cuadro de mando de consulta unificado de todas ellas, independientemente de la marca que sean</li>
                <li className="success">Supervisando 24x7 todas ellas</li>                
                <li className="success">Permitiéndote crear alertas para avisarte en caso de que algo no vaya bien en una o en todas ellas</li>                
                <li className="success">Te tendré al tanto de todo a través de email</li>
                {/*<li className="success">Te tendré al tanto de todo a través de email o Telegram.</li>*/}
              </ul>           
              <p>Si en los siguientes pasos dudas sobre algo busca y pulsa este icono <span className="material-icon tooltip-icon link size-s">info</span>, seguramente te resuelva la duda.</p>   
              <p>Por cierto si por cualquier motivo no puedes completar el registro de una vez no te preocupes, la siguiente vez que accedas lo retomaremos desde donde lo dejaste.</p>
              </>
            }
            
          />

          <fieldset>            
            <button id="opcionAvanzado" className="button primary full-width" onClick={() => navegar()}>¡Comencemos!</button>         
          </fieldset>

        </div>        

        <picture className="main-illustration installer">
          <picture className="layer">
            <img src={InstallerImg} alt="installer"/>
          </picture>
        </picture>

      </section>



    </main>
  )
}

export default Welcome